import React, { useMemo } from 'react';
import feather from 'feather-icons';
import { colors } from '../styleConstants';
export var ICON_COLORS = {
    black: colors.trueBlack,
    white: colors.trueWhite,
    primary: colors.accentTeal,
    warning: colors.accentOrange,
    error: colors.accentRed,
    success: colors.accentMint,
    disabled: colors.primaryGreyMediumLight,
};
export var ICON_SIZE = {
    small: 12,
    medium: 16,
    large: 20,
    extraLarge: 48,
};
var Icon = function (_a) {
    var name = _a.name, size = _a.size, _b = _a.color, color = _b === void 0 ? 'black' : _b;
    var iconSize = useMemo(function () { return ICON_SIZE[size !== null && size !== void 0 ? size : 'medium']; }, [size]);
    var iconColor = color ? ICON_COLORS[color] : undefined;
    var icon = feather.icons[name].toSvg({ width: iconSize, height: iconSize, stroke: iconColor });
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: icon } });
};
export default Icon;
